<div class="dialog-footer">
  <!-- DIVIDER -->
  <mat-divider class="dialog-footer__divider" />

  <!-- CONTENT -->
  <div class="dialog-footer__content">
    <ng-content />
  </div>
</div>
